import React, { useState, useEffect } from "react";


// Redux
import { useDispatch, useSelector } from 'react-redux';
import { addServices } from '../stores/cartSlice';


import TitleComponent from "./TitleComponent";

function AdditionalServiceComponent(props) {

    const dispatch = useDispatch();
    const selectedItems = useSelector((state) => state.cart.additionalServices);
    const [localSelectedItems, setLocalSelectedItems] = useState(selectedItems);

    useEffect(() => {
        setLocalSelectedItems(selectedItems);
    }, [selectedItems]);

    const handleClick = (item) => {
        const newLocalSelectedItems = [...localSelectedItems || []];
        const itemIndex = newLocalSelectedItems.findIndex(x => x.value === item.value);

        if (itemIndex !== -1) {
            newLocalSelectedItems.splice(itemIndex, 1);
        } else {
            newLocalSelectedItems.push(item);
        }

        setLocalSelectedItems(newLocalSelectedItems);
        dispatch(addServices(newLocalSelectedItems)); // Update Redux state
    };

    const isSelected = (val) => {
        if (localSelectedItems) {
            if (localSelectedItems.length > 0)
                return localSelectedItems?.findIndex(x => x.value == val) !== -1;
        }

        return false;

    };


    return (
        <div className="custom-container">
            {props.label ? (<TitleComponent title={props.label} />) : ""}
            <div className="button-container">
                {props.items && props.items.map((item, index) => (
                    <div className="button-space" key={index}>
                        <button
                            disabled={props.disabled}
                            onClick={() => handleClick(item)}
                            type="button"
                            className={`btn btn-success ${isSelected(item.value) ? 'custom-additional-button-selected' : 'custom-additional-button'}`}
                        >
                            {item.text}
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );

}

export default AdditionalServiceComponent;
